"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configConsumerProps = exports.ConfigConsumer = exports.ConfigContext = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var rc_field_form_1 = require("rc-field-form");
var useMemo_1 = tslib_1.__importDefault(require("rc-util/lib/hooks/useMemo"));
var locale_provider_1 = tslib_1.__importStar(require("../locale-provider"));
var LocaleReceiver_1 = tslib_1.__importDefault(require("../locale-provider/LocaleReceiver"));
var context_1 = require("./context");
Object.defineProperty(exports, "ConfigConsumer", { enumerable: true, get: function () { return context_1.ConfigConsumer; } });
Object.defineProperty(exports, "ConfigContext", { enumerable: true, get: function () { return context_1.ConfigContext; } });
var SizeContext_1 = tslib_1.__importStar(require("./SizeContext"));
exports.configConsumerProps = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'locale',
    'pageHeader',
];
// These props is used by `useContext` directly in sub component
var PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'pageHeader',
    'input',
    'form',
];
var ProviderChildren = function (props) {
    var children = props.children, csp = props.csp, form = props.form, locale = props.locale, componentSize = props.componentSize, direction = props.direction, space = props.space, virtual = props.virtual, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, legacyLocale = props.legacyLocale, parentContext = props.parentContext;
    var getPrefixCls = React.useCallback(function (suffixCls, customizePrefixCls) {
        var prefixCls = props.prefixCls;
        if (customizePrefixCls) {
            return customizePrefixCls;
        }
        var mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
    }, [parentContext.getPrefixCls]);
    var config = tslib_1.__assign(tslib_1.__assign({}, parentContext), { csp: csp, locale: locale || legacyLocale, direction: direction, space: space, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, getPrefixCls: getPrefixCls });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    PASSED_PROPS.forEach(function (propName) {
        var propValue = props[propName];
        if (propValue) {
            config[propName] = propValue;
        }
    });
    // https://github.com/ant-design/ant-design/issues/27617
    var memoedConfig = (0, useMemo_1.default)(function () { return config; }, config, function (prevConfig, currentConfig) {
        var prevKeys = Object.keys(prevConfig);
        var currentKeys = Object.keys(currentConfig);
        return (prevKeys.length !== currentKeys.length ||
            prevKeys.some(function (key) { return prevConfig[key] !== currentConfig[key]; }));
    });
    var childNode = children;
    // Additional Form provider
    var validateMessages = {};
    if (locale && locale.Form && locale.Form.defaultValidateMessages) {
        validateMessages = locale.Form.defaultValidateMessages;
    }
    if (form && form.validateMessages) {
        validateMessages = tslib_1.__assign(tslib_1.__assign({}, validateMessages), form.validateMessages);
    }
    if (Object.keys(validateMessages).length > 0) {
        childNode = React.createElement(rc_field_form_1.FormProvider, { validateMessages: validateMessages }, children);
    }
    if (locale) {
        childNode = (React.createElement(locale_provider_1.default, { locale: locale, _ANT_MARK__: locale_provider_1.ANT_MARK }, childNode));
    }
    if (componentSize) {
        childNode = React.createElement(SizeContext_1.SizeContextProvider, { size: componentSize }, childNode);
    }
    return (
    // @ts-ignore
    React.createElement(context_1.ConfigContext.Provider, { value: memoedConfig }, childNode));
};
var ConfigProvider = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(LocaleReceiver_1.default, null, function (_, __, legacyLocale) { return (React.createElement(context_1.ConfigConsumer, null, function (context) { return (React.createElement(ProviderChildren, tslib_1.__assign({ parentContext: context, legacyLocale: legacyLocale }, props))); })); })));
};
/** @private internal usage. do not use in your production */
ConfigProvider.ConfigContext = context_1.ConfigContext;
ConfigProvider.SizeContext = SizeContext_1.default;
exports.default = ConfigProvider;
//# sourceMappingURL=index.js.map